import { InterceptorErros } from "../interface/interceptor.interface";

export const RESPONSE_ERRORS: InterceptorErros[] = [
    {
        ERROR_CODE: 'LOGIN_FAILED',
        MESSAGE: 'Incorrect email or password.'
    }
];

export const ERROR_DEFAULT_MESSAGE = 'Please contact support.';